// src/composables/usePermissions.js

/**
 * Convert flat permission keys into grouped object
 * e.g. ['orders.view', 'orders.edit'] → { orders: ['view','edit'] }
 */
export function normalizePermissions(keys = []) {
  return keys.reduce((acc, key) => {
    const [resource, action] = key.split('.');
    if (!acc[resource]) acc[resource] = [];
    acc[resource].push(action);
    return acc;
  }, {});
}

/**
 * Check if current user can perform an action on a resource.
 * @param {string} resource - e.g. 'orders'
 * @param {string} action - e.g. 'edit'
 * @returns {boolean}
 */
export function hasPermission(resource, action) {
  const stored = JSON.parse(localStorage.getItem('permissions') || '{}');
  const allowed = stored[resource] || [];
  return allowed.includes(action);
}
